import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "container welcome" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "col-12" };
const _hoisted_9 = {
    key: 0,
    class: "row"
};
const _hoisted_10 = { class: "col-12" };
const _hoisted_11 = { class: "welcome__customer-title" };
const _hoisted_12 = { class: "welcome__customer" };
import { onMounted, ref } from 'vue';
import env from '../services/AppEnv';
import HomeLoginRegisterTeaser from "./HomeLoginRegisterTeaser.vue";
import CustomerButton from "./CustomerButton.vue";
import customers from '@astina/paloma-shop-common-ui/src/services/CustomerRepository';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeWelcome',
    setup(__props) {
        const user = env.user;
        const multipleCustomers = ref(false);
        onMounted(() => {
            if (user.authenticated) {
                customers.listCustomers()
                    .then(customers => multipleCustomers.value = customers.length > 1);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["welcome-backdrop", { 'welcome-backdrop--authenticated': _unref(user).authenticated }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h1", null, [
                                (_unref(user).authenticated && _unref(user).firstName)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('home.welcome', { firstName: _unref(user).firstName, lastName: _unref(user).lastName })), 1)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('home.welcome_guest')), 1)
                                    ], 64))
                            ])
                        ])
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("p", null, [
                                (_unref(user).authenticated && _ctx.$t('home.intro.authenticated') && _ctx.$t('home.intro.authenticated') !== 'home.intro.authenticated')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        innerHTML: _ctx.$t('home.intro.authenticated')
                                    }, null, 8, _hoisted_6))
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        innerHTML: _ctx.$t('home.intro')
                                    }, null, 8, _hoisted_7))
                            ])
                        ]),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_8, [
                            (!_unref(user).authenticated)
                                ? (_openBlock(), _createBlock(HomeLoginRegisterTeaser, { key: 0 }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (multipleCustomers.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('customer.client')), 1),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(CustomerButton, { "show-switch-icon": true })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
